module.exports = __webpack_public_path__ + "img/image_case_7.9e5588c0.png";